import { render } from "./AppSettings.vue?vue&type=template&id=ecccd3f8"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/somethingred.j20.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__